export default __webpack_public_path__ + "static/media/left-design.599b5e9a.svg";